// Token types for the formula lexer
export enum TokenType {
    NUMBER,
    STRING,
    IDENTIFIER,
    BOOLEAN,
    LPAREN,
    RPAREN,
    SEMICOLON,
    PLUS,
    MINUS,
    MULTIPLY,
    DIVIDE,
    POWER,
    PERCENT,
    AMPERSAND,
    EQUALS,
    NOT_EQUALS,
    LESS_THAN,
    LESS_EQUAL,
    GREATER_THAN,
    GREATER_EQUAL,
    COLON,
    COMMA,
    EOF
}

export interface Token {
    type: TokenType;
    value: string;
    position: number;
}

// AST node types
export type ASTNode =
    | NumberNode
    | StringNode
    | BooleanNode
    | UnaryOpNode
    | BinaryOpNode
    | PercentNode
    | FunctionCallNode
    | IdentifierNode
    | ArrayNode;

export interface NumberNode {
    type: 'number';
    value: number;
}

export interface StringNode {
    type: 'string';
    value: string;
}

export interface BooleanNode {
    type: 'boolean';
    value: boolean;
}

export interface UnaryOpNode {
    type: 'unaryOp';
    op: '+' | '-';
    operand: ASTNode;
}

export interface BinaryOpNode {
    type: 'binaryOp';
    op: string;
    left: ASTNode;
    right: ASTNode;
}

export interface PercentNode {
    type: 'percent';
    operand: ASTNode;
}

export interface FunctionCallNode {
    type: 'functionCall';
    name: string;
    args: ASTNode[];
}

export interface IdentifierNode {
    type: 'identifier';
    name: string;
}

export interface ArrayNode {
    type: 'array';
    values: number[];
}

// Error types matching HyperFormula's DetailedCellError
export enum FormulaErrorType {
    DIV_BY_ZERO = '#DIV/0!',
    VALUE = '#VALUE!',
    NAME = '#NAME?',
    NUM = '#NUM!',
    REF = '#REF!',
    NA = '#N/A',
    ERROR = '#ERROR!',
    CYCLE = '#CYCLE!'
}

export class FormulaError extends Error {
    public readonly type: FormulaErrorType;

    constructor(type: FormulaErrorType, message?: string) {
        super(message ?? type);
        this.type = type;
        this.name = 'FormulaError';
    }

    toString(): string {
        return `${this.type}: ${this.message}`;
    }
}

// Function implementation type
export type FormulaValue = number | string | boolean | number[] | null;
export type FunctionImpl = (...args: FormulaValue[]) => FormulaValue;
